import { render } from "./IconTravel.vue?vue&type=template&id=5cc947bc"
import script from "./IconTravel.vue?vue&type=script&lang=js"
export * from "./IconTravel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__